import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import Toggle from 'dpl/common/design_system/Toggle';
import MiniOverlayModal from 'dpl/common/mini_overlay_modal/components/MiniOverlayModal';
import useFormContext from 'dpl/shared/form/hooks/useFormContext';

import introCallIllustration from 'dpl/assets/intro_call.png';

const TOGGLE_LABEL = 'Open to a phone or video call';

const MODAL_HEADING = 'Chat before you commit';

const MODAL_BODY =
  'A quick five-minute phone or video call can tell you a lot. Ask questions, ' +
  'get to know the breeder, and see if it feels like the right fit. When you ' +
  'call through Good Dog, your number stays private.';

const ILLUSTRATION_WIDTH = 182;
const ILLUSTRATION_HEIGHT = 200;

export default function OpenToIntroCallQuestion({ name }) {
  const { setValue, formFieldValue } = useFormContext(name);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isChecked = Boolean(formFieldValue ?? true);
  const labelId = `${name}-label`;

  return (
    <div className="OpenToIntroCallQuestion">
      <div className="flex items-center justify-between ba b--default br3 bg-white ph4 pv3">
        <div className="flex items-center gap-8">
          <span id={labelId} className="font-16">
            {TOGGLE_LABEL}
          </span>
          <button
            type="button"
            aria-label={`More about ${TOGGLE_LABEL.toLowerCase()}`}
            className="OpenToIntroCallQuestion__infoButton flex items-center secondary"
            onClick={() => setIsModalOpen(true)}
          >
            <Icon name="fetch-info-24" width="24px" height="24px" />
          </button>
        </div>

        <Toggle
          className="OpenToIntroCallQuestion__toggle"
          checked={isChecked}
          aria-labelledby={labelId}
          dataTestId="open-to-intro-call-toggle"
          onChange={() => setValue(name, !isChecked)}
        />
      </div>

      {isModalOpen && (
        <MiniOverlayModal
          maxWidth="600px"
          onCloseClick={() => setIsModalOpen(false)}
          closeButtonClassName="ba b--default br-100 padding-h-6 padding-v-6 mt4 mr4"
          contentClassName="bg-white pa16"
          dataTestId="open-to-call-modal"
        >
          <div className="flex flex-column items-center tc gap-24">
            <img
              src={introCallIllustration}
              alt=""
              style={{ width: ILLUSTRATION_WIDTH, height: ILLUSTRATION_HEIGHT }}
            />
            <div className="flex flex-column items-center gap-16">
              <h4 className="font-serif font-24 fw-medium">{MODAL_HEADING}</h4>
              <p className="font-16 lh-body secondary">{MODAL_BODY}</p>
            </div>
          </div>
        </MiniOverlayModal>
      )}
    </div>
  );
}

OpenToIntroCallQuestion.propTypes = {
  name: PropTypes.string
};

OpenToIntroCallQuestion.defaultProps = {
  name: 'open_to_intro_call'
};
